// src/App.jsx
import React, { useState } from "react";
import "./stateindicator.css";
import "./passindicator.css";
import IndiaMapQuiz from "./components/IndiaMapQuiz";
import PassesQuiz from "./components/PassesQuiz";
import QuizHeader from "./components/QuizHeader";

export default function App() {
  const [mode, setMode] = useState("india");

  // Sirf state quiz ke liye "More info" toggle
  const [moreInfoEnabled, setMoreInfoEnabled] = useState(true);

  const handleModeChange = (nextMode) => {
    setMode(nextMode);
  };

  const handleToggleMoreInfo = () => {
    setMoreInfoEnabled((prev) => !prev);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        background: "#020617",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "24px 12px",
        boxSizing: "border-box",
      }}
    >
      <div className="quiz-root">
        <QuizHeader
          mode={mode}
          onModeChange={handleModeChange}
          moreInfoEnabled={moreInfoEnabled}
          onToggleMoreInfo={handleToggleMoreInfo}
        />

        {mode === "india" && (
          <IndiaMapQuiz moreInfoEnabled={moreInfoEnabled} />
        )}

        {mode === "passes" && <PassesQuiz />}

        {mode === "world" && (
          <div className="coming-soon-body">
            <div className="coming-card">
              <h2>🌍 World Map Quiz</h2>
              <p>World mode coming soon.</p>
              <p className="coming-sub">
                Abhi ke liye India States & Passes se practice karo.
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
